import { render, staticRenderFns } from "./RevertImpersonationButton.vue?vue&type=template&id=10c09437"
import script from "./RevertImpersonationButton.vue?vue&type=script&lang=js"
export * from "./RevertImpersonationButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports